import type { ReactNode } from 'react';

export const buildMaterialCompletionDescription = (selectedMaterialIds: string[]): ReactNode => (
    <>
        <div>The selected materials will be updated to 'Completed' status. The remarks of these materials will be updated to 'Manually completed'.</div>
        <div style={{ marginTop: 8 }}>
            Selected Materials: <strong>{selectedMaterialIds.join(', ')}</strong>
        </div>
    </>
);
